import { Injectable } from '@angular/core';
import { App } from '@capacitor/app';
import { Platform } from '@ionic/angular';
import { BUILD_INFO } from 'src/build_info';
import { AppVariant, AppVersionInfo } from 'src/shared/api_types';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  constructor(private platform: Platform) { }

  get isMobileApp(): boolean {
    return this.platform.is('hybrid')
  }

  getAppVariant(): AppVariant {
    if (this.platform.is('hybrid')) {
      if (this.platform.is('ios')) {
        return 'ios'
      }
      if (this.platform.is('android')) {
        return 'android'
      }
      throw new Error('unknown hybrid platform')
    }
    return 'web'
  }

  async buildAppVersionInfo(): Promise<AppVersionInfo> {
    let versionInfo: AppVersionInfo = {
      variant: this.getAppVariant(),
      gitBuildInfo: BUILD_INFO,
    }
    // on the mobile apps, get the app version info
    if (this.platform.is('hybrid')) {
      const appInfo = await App.getInfo()
      console.debug('App info:', JSON.stringify(appInfo))
      versionInfo.version = appInfo.version
      versionInfo.build = appInfo.build
    }
    return versionInfo
  }
}
